import React, { useState } from "react";
import { Alert, Form, message, Divider, Upload, Tooltip, Table } from "antd";
import {
  SaveButton, CancelButton, ModalComponent, trans,
  ButtonComponent

} from "@comps/components"
import { makeRequestStateless } from "@utils/helpers";
import { importSampleReq } from "./requests";
import { Const } from "./constants";
import { useSelector } from "react-redux";

const langKey = Const["import"].lngKey
const formName = "importAttendance";

const ImportSample = (props) => {
  const authUser = useSelector((state) => state.auth.authUser);
  const [saving, setSaving] = useState(false)
  const [childComponent, setChildComponent] = useState(null)
  const [hasErrors, setHaserrors] = useState(false);

  const renderResults = (errors = [], summary = null) => (
    <>
      { summary && (
        <>
          <Divider>Import Summary</Divider>
          <Alert
            type={ summary.failed > 0 ? "warning" : "success" }
            showIcon
            message={ `${summary.created} created, ${summary.failed} failed` }
          />
        </>
      ) }

      { errors.length > 0 && (
        <>
          <Divider className="text-danger">Importing Errors</Divider>

          <Table
            scroll={ { x: 'max-content', y: 'max-content' } }
            columns={ errorColumns }
            dataSource={ errors }
            pagination={ false }
          />
        </>
      ) }
    </>
  );


  const getMessage = (message) => {
    if (message.includes("out of bounds")) {
      const matches = [...message.matchAll(/\[(.*?)\]/g)];
      if (matches.length > 0) {
        const sheetname = matches.map(match => match[1]);
        return "Sheet not found.create or update sheet name to " + sheetname;
      } else {
        return message;
      }
    }
    return message;
  }
  const errorColumns = [
    {
      key: 'row',
      title: trans(`${langKey}.row`),
      dataIndex: "row",
    },
    {
      key: 'column',
      title: trans(`${langKey}.column`),
      dataIndex: "column",
    },
    {
      key: 'value',
      title: trans(`${langKey}.value`),
      dataIndex: "value",
    },
    {
      key: 'message',
      title: trans(`${langKey}.message`),
      render: (record) => (
        getMessage(record.message)
      ),
    },
  ]

  const onSubmit = (data) => {

    let file = null
    if (data.file_attachment === undefined) {
      message.info("Please Select File To Import!")
      return
    }
    if (data.file_attachment !== undefined) {
      file = data.file_attachment.fileList.length > 0 ? data.file_attachment.file : null
    }
    const payload = { api: props.api, file_attachment: file, attendance_log_import: { attachment: { removed: false, org_name: file.name, key: "attachment" } }, user: authUser };
    setSaving(true)
    makeRequestStateless(importSampleReq, payload, onSuccess, onError);
  }


  const onSuccess = (data, res) => {
    const errors = Array.isArray(data?.errors) ? data.errors : [];
    const createdCount = Number(data?.created_count || 0);
    const failedCount = Number(
      data?.failed_count !== undefined ? data.failed_count : errors.length
    );

    setSaving(false)
    if (createdCount > 0 && props.onSuccess) {
      props.onSuccess()
    }

    if (data && (data.created_count !== undefined || data.failed_count !== undefined)) {
      if (failedCount === 0) {
        message.success(res.message || `${createdCount} created, 0 failed`);
        props.onCompleted(null)
        setChildComponent(null)
        setHaserrors(false)
        return
      }

      setHaserrors(true)
      setChildComponent(renderResults(errors, { created: createdCount, failed: failedCount }))
      message.warning(res.message || `${createdCount} created, ${failedCount} failed`)
      return
    }

    if (data && data.errors && data.errors.length !== undefined && data.errors.length === 0) {
      message.success(res.message);
      props.onCompleted(null)
      setChildComponent(null)
      setHaserrors(false)
      props.onSuccess()
    }
    if (data.errors !== undefined && data.errors.length > 0) {
      setHaserrors(true)
      setChildComponent(renderResults(data.errors))
    }
  }

  const onError = (err, res) => {
    setHaserrors(true)
    setSaving(false)
    setChildComponent(null);
    message.error('Server Side Error!');
    if (res.response !== undefined) {
      message.error(res.response.data.message);
    }
  }

  //============uploading file============
  const [fileList, setFileList] = useState([]);

  const onChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  //=========================================
  const footer = [
    <SaveButton form={ formName } key="create_button" htmlType="submit" loading={ saving } />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 50 } width={ 1400 } maskClosable={ false }
      mainTitle={ trans(`${langKey}.import`) } subTitle={ props.module }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>

      <Form name={ formName } onFinish={ onSubmit } scrollToFirstError>

        { !hasErrors && <Form.Item name="file_attachment" rules={ rules.file_attachment } label={ trans(`${langKey}.file_attachment`) }
          className="da-mb-16"
          size="small"
        >
          <Upload
            accept=".xlsx"
            listType="picture"
            fileList={ fileList }
            onChange={ onChange }
            //onPreview={ onPreview }
            multiple={ false }
            beforeUpload={ (file) => {
              return false;
            } }
          >
            { fileList.length === 1 ? null : <Tooltip title="Drag & Drop or choose file"> <ButtonComponent text="Upload" /></Tooltip> }
          </Upload>
        </Form.Item> }

      </Form>

      { childComponent }
    </ModalComponent>
  )
}

export default ImportSample

const rules = {
  file_attachment: [
    { required: true, message: trans(`${langKey}.file_attachment`) },
  ],

};
